import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { createAuthModule } from '@evidentid/dashboard-commons/modules/auth';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import Logger from '@evidentid/logger';
import RpWebApiClient from '@evidentid/rpweb-api-client';
import Tracker from '@evidentid/tracker';

import Dashboard from '@/modules/dashboard/views/Dashboard.vue';
import { useDashboardStore } from '@/modules/dashboard/vuex/dashboard';
import { observeTrackAndLogOnStore } from '@/utils/vuex-common/observeTrackAndLog';

import UploadEntityDocumentProcedure from './procedures/UploadEntityDocumentProcedure.vue';

function trackAndLog(app: any): void {
    const dashboardStore = useDashboardStore(app.getPinia());
    const module = 'Dashboard';
    observeTrackAndLogOnStore(app, dashboardStore,
        { start: 'startEntitiesListUpdate', finish: 'pushToEntitiesList', fail: 'failEntitiesListUpdate' },
        { module, title: 'Entities', action: 'Get' },
    );
    observeTrackAndLogOnStore(app, dashboardStore,
        { start: 'startLoadingCustomProperties', finish: 'finishLoadingCustomProperties', fail: 'failLoadingCustomProperties' },
        { module, title: 'Custom Properties', action: 'Get' },
    );
    observeTrackAndLogOnStore(app, dashboardStore,
        { start: 'startLoadingRequirementTypes', finish: 'finishLoadingRequirementTypes', fail: 'failLoadingRequirementTypes' },
        { module, title: 'Requirement Types', action: 'Get' },
    );

    observeTrackAndLogOnStore(app, dashboardStore,
        { start: 'startLoadingEntityStatistics', finish: 'finishLoadingEntityStatistics', fail: 'failLoadingEntityStatistics' },
        { module, title: 'Entity Statistics', action: 'Get' },
    );
    observeTrackAndLogOnStore(app, dashboardStore,
        { start: 'startLoadingRequestsConfig', finish: 'finishLoadingRequestsConfig', fail: 'failLoadingRequestsConfig' },
        { module, title: 'Requests Config', action: 'Get' },
    );
    observeTrackAndLogOnStore(app, dashboardStore,
        { finish: 'updateRiskRequirementDefinitions' },
        { module, title: 'Risk Requirement Definitions', action: 'Get' },
    );
    observeTrackAndLogOnStore(app, dashboardStore,
        { start: 'startLoadingCredentialTypes', finish: 'finishLoadingCredentialTypes', fail: 'failLoadingCredentialTypes' },
        { module, title: 'Credential Types', action: 'Get' },
    );
    observeTrackAndLogOnStore(app, dashboardStore,
        { start: 'startUploadingContract', finish: 'finishUploadingContract', fail: 'failUploadingContract' },
        { module, title: 'Contract Upload', action: 'Post' },
    );
}

export const dashboardModule = createModuleBuilder()
    .registerRoutes(() => [
        {
            path: '/:rpId?/dashboard',
            name: 'dashboard',
            component: Dashboard as any,
            meta: { title: 'Dashboard', pageClass: 'Dashboard' },
        },
    ])
    .demandContext<{
    rpweb: RpWebApiClient;
    gatewayClient: GatewayApiClient;
    tracker?: Tracker<any>;
    logger?: Logger<any>;
}>()
    .demand<ReturnType<typeof createAuthModule>>()
    .registerProcedures<{
    uploadEntityDocumentProcedure: { rpName: string, entityId: string };
}>({
        uploadEntityDocumentProcedure: UploadEntityDocumentProcedure,
    })
    .execute((app) => {
        trackAndLog(app);
    })
    .end();
